<template>
  <div id="app">
    <header>
      <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
        <b-navbar-brand href="#">Plenumado Backoffice</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav v-if="authenticated">
          <b-navbar-nav>
            
            <b-nav-item to="/">Dashboard</b-nav-item>

            <b-nav-item-dropdown text="Bestellungen">
              <b-dropdown-item to="/orders">Fakturierte Bestellungen</b-dropdown-item>
              <b-dropdown-item to="/open_orders">Offene Bestellungen</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown text="Artikel">
              <b-dropdown-item to="/articles_bought">Verkaufte Artikel</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown text="Lager">
              <b-dropdown-item to="/stocks">Lagerbestand</b-dropdown-item>
              <b-dropdown-item to="/stock_history">Lagerverlauf</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown text="Administration" v-if="user_master == 1">
              <b-dropdown-item to="/admin_users">Benutzer</b-dropdown-item>
              <b-dropdown-item to="/admin_article_amazon_mapping">AMAZON - Artikelmapping</b-dropdown-item>
              <b-dropdown-item to="/admin_article_shop_mapping">Shop - Artikelmapping</b-dropdown-item>
            </b-nav-item-dropdown>

          </b-navbar-nav>

          
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!--
            <b-nav-form>
              <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
            </b-nav-form>
            -->

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                Benutzer
              </template>
              <b-dropdown-item href="#" v-on:click="do_logout">{{user_name}} abmelden</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>

    <router-view @authenticated="setAuthenticated"></router-view>

  </div>
</template>

<script>
import axios from 'axios'
const request = require('superagent')

export default {
  name: 'App',
  data: function () {
    return {
      api_token: null,
      api_shop_ids: [],
      user_master: 0,
      user_number: null,
      user_password: null,
      user_name: null,
      login_msg: null,
      authenticated: 0
    }
  },
  beforeMount () {
    this.isLoggedIn()
  },
  methods: {
    toggleNav (){
      if(document.getElementById("navbarCollapse").classList.contains('show')){
        document.getElementById("navbarCollapse").classList.remove('show');
      }else{
        document.getElementById("navbarCollapse").classList.add('show');
      }
    },
    setAuthenticated (status) {
      this.authenticated = status
      if (status === 0) {
        localStorage.setItem('API_TOKEN', '')
        this.$router.replace({ name: 'Login' })
        // this.user_data = {}
      } else {
       axios
        .get(process.env.API_HOST + '/api/auth/info',{ headers: { Authorization: localStorage.getItem('API_TOKEN') } })
        .then(response => {
          this.user_name = response.data.user_name
          this.user_master = response.data.master
          this.$store.commit('set_current_user',response.data)
        })
        .catch(error => {
          this.setAuthenticated(0)
          this.$router.replace({ name: 'Login' })
          })
      }
    },
    isLoggedIn () {
      axios
        .get(process.env.API_HOST + '/api/auth/info',{ headers: { Authorization: localStorage.getItem('API_TOKEN') } })
        .then(response => {
          this.setAuthenticated(1)
          this.user_name = response.data.user_name
          this.$store.commit('set_user_name',response.data.user_name)
          this.$store.commit('set_current_user',response.data)
          this.loadBaseData()
        })
        .catch(error => {
          this.setAuthenticated(0)
          this.$router.replace({ name: 'Login' })
        })
    },
    do_logout () {
      this.user_number = null
      this.user_password = null
      this.api_token = null
      this.api_shop_ids = null
      this.user_name = null
      this.login_msg = null
      localStorage.setItem('API_TOKEN', null)
      this.setAuthenticated(0)
    },
    loadBaseData(){
      var that = this;

      // storing the api key
      this.$store.commit('set_api_key',localStorage.getItem('API_TOKEN'))

      // loading the shops for the user
      request
          .get(process.env.API_HOST + '/api/shops')
          .set('Accept', 'application/json')
          .set('Authorization',localStorage.getItem('API_TOKEN'))
          .then(function (res) {
              that.$store.commit('set_shops',res.body)
          })
    }
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

html, body {
  font-family: 'Roboto Condensed', sans-serif;
  background-color: #f6f8fa;
}

#app {
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

.table > tbody > tr> td{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.table > thead > tr> th{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
  background-color: yellow;
}

 .table-small{
   font-size: 0.75em;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue